export const siteText = {
  firstWord: 'NAILS ',
  lastWord: 'NAILS ',
};